import { getLoanOperation } from "../../libs/cognito-api/loan-operation/loan-operation";
import type { InstallmentDto, LoanOperationListDto } from "../../libs/cognito-api/schemas";
import { buildDebtFlowTable, ExcelTable, findLoanBySequentialId } from "./loan-flow";

const loanOperationApi = getLoanOperation();

export async function getLoanDebtFlowTable(sequentialId: string | number): Promise<ExcelTable> {
  const loan = await resolveLoanBySequentialId(sequentialId);
  const response = await loanOperationApi.getLoanOperationsId(loan.id);

  if (!response.status || !response.data) {
    throw new Error(response.message || "Nao foi possivel buscar o fluxo da divida.");
  }

  const installments = response.data.flowParams?.installments ?? [];
  return buildDebtFlowTable(installments);
}

async function resolveLoanBySequentialId(sequentialId: string | number): Promise<LoanOperationListDto & { id: string }> {
  const response = await loanOperationApi.getLoanOperations({
    Filter: String(sequentialId),
    Page: 1,
    PageSize: 20,
  });

  if (!response.status || !response.data) {
    throw new Error(response.message || "Nao foi possivel buscar a operacao de credito.");
  }

  const loans = response.data.data ?? [];
  const loan = findLoanBySequentialId(loans, sequentialId);

  if (!loan?.id) {
    throw new Error(`Operacao ${String(sequentialId)} nao encontrada.`);
  }

  return loan as LoanOperationListDto & { id: string };
}

export type { InstallmentDto };
